import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { DEMO } from "@/demo/demo";
import { seedDemoSession } from "@/demo/bootstrap";

// No QueryClientProvider: @tanstack/react-query was mounted here with zero
// consumers — useQuery/useMutation appear nowhere in the app. Data fetching is
// hand-rolled useState + polling in hooks/ and features/dossiers/hooks/.
// The dependency is still declared in package.json: dropping it needs yarn.lock
// regenerated, which the audit environment could not reach the registry to do
// (ARCHITECTURE_AUDIT W-09). Remove it in that same pass.

const root = ReactDOM.createRoot(document.getElementById("root"));
const render = () => root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if (DEMO) seedDemoSession().then(render);
else render();
